<template>
  <div
    class="boxOS mb-4">
    <div class="boxOS_header p-2"
         :class="{ 'boxOS_headerDisabled': item.flag_cancelado }">
      <div class="row">
        <div class="col">
          <h3 class="boxOS_header_title">
            {{ item.custa.ato }}
          </h3>
        </div>
      </div>
    </div>
    <b-modal v-if="imprimirRecibo"
             :id="`imprimirRecibo_${_uid}`"
             :ref="`imprimirRecibo_${_uid}`"
             :hide-header="true"
             :visible="true"
             centered
             @hide="cancelModalImpRecido()"
             @ok="continueModalImpRecido()">
      <p class="textModalImpRecibo">
        Este item não possui selo, portanto ele será impresso sem o QR Code.
      </p>

      <div slot="modal-footer"
           slot-scope="{ ok, cancel }">
        <button id="btn-cancel-imprimir-recibo"
                class="btn btn-sm btn-dark mr-2"
                @click="cancelModalImpRecido()">
          Voltar
        </button>
        <button id="btn-submit-imprimir-recibo"
                class="btn btn-sm btn-primary"
                type="submit"
                @click="continueModalImpRecido()">
          Continuar
        </button>
      </div>
    </b-modal>

    <div class="boxOS_body px-2 py-2"
         :class="{ 'boxOS_bodyDisabled': item.flag_cancelado }">
      <div class="boxOS_body_content">
        <div class="d-inline-block ">
          <ul class="boxOS_list">
            <li class="boxOS_list_item boxOS_list_title">
              Tabela do cartório
            </li>

            <li class="boxOS_list_item">
              <IconSvg v-if="item.tabelaCartorio"
                       class="icon-done"
                       :class="{'icon-done-disabled': item.flag_cancelado }"
                       icon="done" />
              <IconSvg v-else
                       class="icon-close"
                       :class="{'icon-close-disabled': item.flag_cancelado }"
                       icon="close2" />
            </li>
          </ul>
        </div>

        <div class="d-inline-block">
          <ul class="boxOS_list">
            <li class="boxOS_list_item boxOS_list_title">
              Zerar custas
            </li>

            <li class="boxOS_list_item">
              <IconSvg v-if="item.flag_zerar_custas"
                       class="icon-done"
                       :class="{'icon-done-disabled': item.flag_cancelado }"
                       icon="done" />
              <IconSvg v-else
                       class="icon-close"
                       :class="{'icon-close-disabled': item.flag_cancelado }"
                       icon="close2" />
            </li>
          </ul>
        </div>

        <div class="d-inline-block">
          <ul class="boxOS_list">
            <li class="boxOS_list_item boxOS_list_title">
              Gerar selo
            </li>

            <li class="boxOS_list_item">
              <IconSvg v-if="item.flag_gerar_selo "
                       class="icon-done"
                       :class="{ 'icon-done-disabled': item.flag_cancelado }"
                       icon="done" />
              <IconSvg v-else
                       class="icon-close"
                       :class="{ 'icon-close-disabled': item.flag_cancelado }"
                       icon="close2" />
            </li>
          </ul>
        </div>

        <div class="d-inline-block">
          <ul class="boxOS_list">
            <li class="boxOS_list_item boxOS_list_title">
              Assento - gerar selo
            </li>

            <li class="boxOS_list_item">
              <IconSvg v-if="item.seloAssento"
                       class="icon-done"
                       :class="{ 'icon-done-disabled': item.flag_cancelado }"
                       icon="done" />
              <IconSvg v-else
                       class="icon-close"
                       :class="{ 'icon-close-disabled': item.flag_cancelado }"
                       icon="close2" />
            </li>
          </ul>
        </div>

        <div class="d-inline-block">
          <ul class="boxOS_list">
            <li class="boxOS_list_item boxOS_list_title">
              Certidão - gerar selo
            </li>

            <li class="boxOS_list_item">
              <IconSvg v-if="item.seloCertidao"
                       class="icon-done"
                       :class="{ 'icon-done-disabled': item.flag_cancelado }"
                       icon="done" />
              <IconSvg v-else
                       class="icon-close"
                       :class="{ 'icon-close-disabled': item.flag_cancelado }"
                       icon="close2" />
            </li>
          </ul>
        </div>

        <div class="d-inline-block">
          <ul class="boxOS_list">
            <li class="boxOS_list_item boxOS_list_title">
              Quantidade
            </li>

            <li class="boxOS_list_item">
              <strong>{{ item.quantidade }}</strong>
            </li>
          </ul>
        </div>
        <div class="d-inline-block">
          <ul class="boxOS_list">
            <li class="boxOS_list_item boxOS_list_title">
              Averbação
            </li>

            <li class="boxOS_list_item">
              <strong>{{ item.averbacao }}</strong>
            </li>
          </ul>
        </div>

        <div class="d-inline-block">
          <ul class="boxOS_list">
            <li class="boxOS_list_item boxOS_list_title">
              Valor
            </li>

            <li class="boxOS_list_item">
              <strong>{{ item.valor || item._valor | moneyToString }}</strong>
            </li>
          </ul>
        </div>

        <div class="d-inline-flex align-items-center">
          <button v-if="!!item.ordem_servico_item_id"
                  class="btn btn-sm btn-light mr-2"
                  @click="cancelItem()">
            {{ item.flag_cancelado ? 'Restaurar': 'Cancelar' }} item
          </button>
          <button v-if="!item.ordem_servico_item_id"
                  class="btn btn-sm btn-danger mr-2"
                  @click="deleteItem()">
            Excluir
          </button>
          <button class="btn btn-sm btn-primary mr-0"
                  @click="editItem()">
            {{ item.ordem_servico_item_id ? 'Visualizar' : 'Editar' }}
          </button>
        </div>
      </div>
    </div>

    <div v-if="openBoxSelo && item.seloItemOs && item.seloItemOs.length > 0"
         class="row no-gutters col-12 mt-2 ListagemSelo">
      <div class="listagemSeloHeader">
        <button class="boxOS_openDetails listagemSeloHeader"
                @click="openBoxSelo = !openBoxSelo">
          Selos
          <svg class="boxOS_openDetails_icon icon--xxs pl-1 ml-1"
               :class="{ 'boxOS_rodate_button': openBoxSelo }"
               role="presentation">
            <use :xlink:href="'#' + arrowDown.id" />
          </svg>
        </button>
      </div>
      <table v-for="(seloItemOs, index) in item.seloItemOs"
             :key="index"
             class="ListagemSelo ListagemSelo_border_all mt-2">
        <tr :key="index">
          <th class="col-sm-2 col-2 pl-1 pt-2 pr-0">
            <span class="boxOS_list_item boxOS_list_title font-weith">
              {{ item.seloItemOs.length > 1 ? 'Selos' : 'Selo' }}
            </span>
          </th>

          <th class="col-sm-1 col-1 text-left pl-3 pt-2 pr-0">
            <span class="boxOS_list_item boxOS_list_title font-weith">
              Data de geração do selo
            </span>
          </th>

          <th class="col-sm-1 col-1 text-left pl-0 pt-2 pr-0">
            <span class="boxOS_list_item boxOS_list_title font-weith">
              Envio TJ
            </span>
          </th>

          <th class="col-sm-1 col-1 text-left pl-0 pt-2 pr-0">
            <span class="boxOS_list_item boxOS_list_title font-weith">
              Cancelado TJ
            </span>
          </th>

          <th class="col-sm-1 col-1 text-left pl-0 pt-2 pr-0">
            <span class="boxOS_list_item boxOS_list_title font-weith">
              Excluído TJ
            </span>
          </th>

          <th class="col-sm-1 col-1 text-left pl-0 pt-2 pr-0">
            <span class="boxOS_list_item boxOS_list_title font-weith">
              Selo retificado
            </span>
          </th>

          <th class="col-sm-1 col-1 text-left pl-2 pt-2 pr-0">
            <span class="boxOS_list_item boxOS_list_title font-weith">
              Ações
            </span>
          </th>

          <th class="col-sm-1 col-1 text-left pl-0 pr-0 pt-2">
            <span class="boxOS_list_item boxOS_list_title font-weith" />
          </th>
        </tr>



        <tr :key="`selos_os_${seloItemOs.selo_id}`"
            class="text-left">
          <td class="col-sm-2 pl-1 pr-0">
            {{ seloItemOs.selo.num_selo }}
          </td>

          <td class="col-sm-2 text-left pl-3 pr-0">
            <span v-if="seloItemOs.selo.created_at">
              {{ seloItemOs.created_at }}
            </span>
          </td>

          <td class="col-sm-2 text-left pl-0 pr-0">
            <span v-if="seloItemOs.selo.data_envio_tj">
              {{ seloItemOs.selo.dataEnvio }}
            </span>

            <IconSvg class="mb-1"
                     :class="seloItemOs.selo.envio_tj ? 'icon-done' : 'icon-close'"
                     :icon="seloItemOs.selo.envio_tj ? 'done' : 'close2'" />
          </td>

          <td class="col-sm-2 text-left pl-0 pr-0">
            <span v-if="seloItemOs.selo.cancelado_tj && seloItemOs.selo.data_cancelamento">
              {{ seloItemOs.selo.dataCancelamento }}

              <IconSvg class="mb-1 icon-done"
                       icon="done" />
            </span>

            <span v-else>
              -
            </span>
          </td>

          <td class="col-sm-2 text-left pl-0 pr-0">
            <span v-if="seloItemOs.selo.excluido_tj">
              {{ seloItemOs.selo.dataExcluido }}

              <IconSvg class="mb-1 icon-done"
                       icon="done" />
            </span>

            <span v-else>
              -
            </span>
          </td>

          <td class="col-sm-1 text-left pl-0 pr-0">
            <span v-if="seloItemOs.selo.num_selo_retificador" />

            <IconSvg class="mb-1"
                     :class="seloItemOs.selo.num_selo_retificador ? 'icon-done' : 'icon-close'"
                     :icon="seloItemOs.selo.num_selo_retificador ? 'done' : 'close2'" />
          </td>

          <td class="col-sm-2 lh-1 text-left pl-0 pr-0">
            <BoxOsModalQrCode :prop-run="runQrCode"
                              :show-btn="false"
                              :prop-registro="propRegistro"
                              :prop-url="seloItemOs.selo.qrcode"
                              @runDisable="runQrCodeDisable" />

            <BoxOsModal :prop-run="runVinculacoes"
                        :show-btn="false"
                        :prop-registro="propRegistro"
                        :prop-selo-item-os="seloItemOs"
                        @runDisable="runQrCodeDisable" />

            <div class="selos-table mb-2">
              <b-dropdown id="dropdown-1"
                          right
                          block="true"
                          text="Visualizar"
                          class="m-md-2"
                          size="sm">
                <b-dropdown-item :disabled="!seloItemOs.selo.envio_tj"
                                 @click="acessarSeloTJ(seloItemOs.selo.qrcode)">
                  Acessar TJ
                </b-dropdown-item>
                <b-dropdown-item-button v-b-modal="`modal-${seloItemOs.selo.qrcode}`"
                                        :disabled="!seloItemOs.selo.qrcode"
                                        @click="runActionsVisualizar('QrCode')">
                  QR Code
                </b-dropdown-item-button>
                <b-dropdown-item-button :id="`selos_os_${seloItemOs.selo_id}`"
                                        v-b-modal="`modal_${seloItemOs.selo_id}`"
                                        :disabled="seloItemOs.selo.vinculacoes.length < 1"
                                        @click="runActionsVisualizar('Vinculacoes')">
                  Vinculações
                </b-dropdown-item-button>
                <b-tooltip placement="right"
                           :disabled.sync="seloItemOs.selo.vinculacoes.length > 0"
                           :target="`selos_os_${seloItemOs.selo_id}`">
                  Este selo não possui vinculações
                </b-tooltip>
              </b-dropdown>
              <button class="btn btn-sm btn-outline-primary mr-1"
                      :disabled="!seloItemOs.selo.envio_tj"
                      @click="!seloItemOs.selo.cancelado_tj && !seloItemOs.selo.excluido_tj ? retificarSelo(seloItemOs.selo) : showModalRet(seloItemOs.selo)">
                Retificar
              </button>
            </div>
          </td>
        </tr>
      </table>
    </div>

    <div v-if="item.seloItemOs && item.seloItemOs.length > 0"
         class="mt-2 row no-gutters">
      <button class="boxOS_openDetails w-100 text-center"
              @click="openBoxSelo = !openBoxSelo">
        <svg class="boxOS_openDetails_icon icon--xxs mt-1 mb-1"
             :class="{ 'boxOS_rodate_button': openBoxSelo }"
             role="presentation">
          <use :xlink:href="'#' + arrowDown.id" />
        </svg>
      </button>
    </div>
    <b-modal v-if="showModalRetificacao"
             id="ConfirmacaoRetificacao"
             centered
             visible
             size="lg"
             title="Alerta!"
             @ok="retificarSelo(seloModalRetificao)"
             @hide="closeModalRet()">
      <div class="d-block text-left">
        <div class="row mr-0 ml-0">
          Esse selo: {{ seloModalRetificao.num_selo }} está {{ seloModalRetificao.cancelado_tj ? 'cancelado por ordem judicial' : 'excluído' }} no TJ.
        </div>

        <div class="row mt-3 mr-0 ml-0">
          Caso deseje continuar, esse selo vai voltar para o tipo de ato quando foi criado.
        </div>

        <div v-if="descricaoSelo">
          <div class="row mt-3 mr-0 ml-0">
            Tipo de ato quando foi criado:
          </div>

          <div class="row mr-0 ml-3">
            <li>{{ seloModalRetificao.tipo_ato }}: {{ descricaoSelo }}</li>
          </div>
        </div>

        <div class="row mt-3 mr-0 ml-0">
          Tem certeza que deseja retificar esse selo?
        </div>
      </div>

      <template #modal-footer="{ ok, cancel }">
        <b-button class="px-4 mr-2"
                  size="sm"
                  variant="danger"
                  @click="cancel()">
          Não
        </b-button>

        <b-button class="px-4"
                  size="sm"
                  variant="secondary"
                  @click="ok()">
          Sim
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  /* assets */
  import arrowDown from "@/assets/icons/arrow-down.svg?sprite"

  /* services */
  import SelosService from "@/services/Registros/SelosService"

  /* constants */
  import { getDescricaoAtoByCodigo } from "@/constants/atosCustas"

  /* Components */
  import BoxOsModal from "@/components/SofiaRei/Resumo/OrdensServico/BoxOsModal.vue"
  import BoxOsModalQrCode from "@/components/SofiaRei/Resumo/OrdensServico/BoxOsModalQrCode.vue"

  import moment from 'moment'

  export default {
    name: 'BoxOS',
    components: {
      BoxOsModal,
      BoxOsModalQrCode
    },
    props: {
      propItem: { type: Object, default: () => ({}) },
      propIndex: { type: Number, default: () =>  -1 },
      propTipo: {type: String, default: () => ''},
      propUpdate: {type: Boolean, default: false},
      propRegistro: { type: Object, default: () => { return {} }},
    },
    data () {
      return {
        arrowDown,
        item: {
          custa: {}
        },
        imprimirRecibo: false,
        openBoxSelo: true,
        qrcodeModal: null,
        urlQrcodeModal: null,
        // showTooltip: false,
        showModalRetificacao: false,
        seloModalRetificao: null,
        descricaoSelo: null,
        runQrCode: false,
        runVinculacoes: false
      }
    },
    watch: {
      propItem () {
        this.item =  this.propItem ? {...this.propItem} : null
        this.item.custa = this.propItem && this.propItem.custa ? {...this.propItem.custa} : null
        this.init()
      },
      'propItem.flag_cancelado' () {
        this.item =  {...this.propItem}
        this.item.custa = {...this.propItem.custa}
      },
      'propUpdate' () {
        if (this.propUpdate) {
          this.item =  this.propItem ? {...this.propItem} : null
        }
      }
    },
    created () {
      this.init()
    },
    methods: {
      init () {
        this.item =  this.propItem
        this.item.custa = {...this.propItem.custa}

        if (!!this.item.seloItemOs) {
          for (const seloItemOs of this.item.seloItemOs) {
            if (seloItemOs.selo.data_envio_tj) {
              seloItemOs.selo.dataEnvio = moment(seloItemOs.selo.data_envio_tj).format('DD/MM/YYYY - HH:mm:ss')
            }

            if (seloItemOs.selo.data_cancelamento) {
              if (moment(seloItemOs.selo.data_cancelamento).format('HH:mm:ss') === '00:00:00') {
                seloItemOs.selo.dataCancelamento = moment(seloItemOs.selo.updated_at).format('DD/MM/YYYY - HH:mm:ss')
              } else {
                seloItemOs.selo.dataCancelamento = moment(seloItemOs.selo.data_cancelamento).format('DD/MM/YYYY - HH:mm:ss')
              }
            }

            if (seloItemOs.selo.excluido_tj) {
              seloItemOs.selo.dataExcluido = moment(seloItemOs.selo.updated_at).format('DD/MM/YYYY - HH:mm:ss')
            }

            seloItemOs.selo.created_at = seloItemOs.selo.created_at ? moment(seloItemOs.selo.created_at).format('DD/MM/YYYY - HH:mm:ss') : '-'

            if (seloItemOs.selo.tipo_ato) {
              // Verificamos se o item possui selo de Assento ou Certidão para exibir na box
              this.item.seloCertidao = seloItemOs.selo.tipo_ato == 'CE' ? true : false
              this.item.seloAssento = ['AC', 'AN', 'AO', 'NT'].indexOf(seloItemOs.selo.tipo_ato) !== -1 ? true : false
            }
          }
        }
      },
      printRecibo () {
        if (!!this.item.seloItemOs.length) {
          this.$emit('imprimir', this.item)
        }

        this.imprimirRecibo = !this.item.seloItemOs.length
      },
      cancelModalImpRecido () {
        this.imprimirRecibo = false
        this.$root.$emit('bv::hide::modal', `imprimirRecibo_${this._uid}`)
      },
      continueModalImpRecido () {
        this.imprimirRecibo = false
        this.$emit('imprimir', this.item)
      },
      async deleteItem () {
        this.$emit('deleteItem', this.propIndex)
      },
      cancelItem () {
        this.$emit('cancelItem')
      },
      editItem () {
        this.$emit('editItem', this.propIndex)
      },
      async displayQuestion (title, text) {
        objSwal.question.title = title
        objSwal.question.text = text
        objSwal.question.cancelButtonText = 'Não'
        objSwal.question.confirmButtonText = 'Sim'

        return await Swal.fire(objSwal.question)
      },
      acessarSeloTJ (qrcodeSelo) {
        window.open(qrcodeSelo)
      },
      runActionsVisualizar (btnAction) {
        switch (btnAction) {
        case 'QrCode':
          this.runQrCode = true
        case 'Vinculacoes':
          this.runVinculacoes = true
        }
      },
      runQrCodeDisable () {
        this.runQrCode = false
        this.runVinculacoes = false
      },
      showModalRet (selo) {
        this.showModalRetificacao = true
        this.seloModalRetificao = selo
        this.descricaoSelo = getDescricaoAtoByCodigo(selo.tipo_ato)
      },
      closeModalRet () {
        this.showModalRetificacao = false
        this.seloModalRetificao = null
        this.descricaoSelo = null
      },
      async retificarSelo (selo) {
        if (!selo.cancelado_tj && !selo.excluido_tj) {
          const res = await displayMessage('question', '', 'Tem certeza que deseja retificar esse selo?', {
            cancelButtonText: 'Não',
            confirmButtonText: 'Sim'
          })

          if (!res.value) return
        }

        loader({ text: 'Aguarde...', active: true })

        try {
          await SelosService.retificarSelo(selo.selo_id)

          setTimeout(() => {
            const btnConfirm = document.querySelector('.swal2-confirm')

            if (btnConfirm) btnConfirm.focus()
          }, 200)

          this.$emit('rechargeOS')

          await displayMessage('success', '', 'Retificação feita com sucesso!')
        } catch (e) {
          console.error('Erro retificar selo: ', e)

          setTimeout(() => {
            const btnConfirm = document.querySelector('.swal2-confirm')

            if (btnConfirm) btnConfirm.focus()
          }, 200)

          await displayMessage('error', 'Erro!', 'Não foi possível realizar a retificação. Tente novamente.')
        } finally {
          loader({ text: '', active: false })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/scss/_utilities/_exports';

  /deep/ .modal-body {
    padding-bottom: 0;
  }

  /deep/ .modal-footer {
    border-top: 0;
  }

  .textModalImpRecibo {
    margin-bottom: 0;
  }

  .boxOS {
    box-shadow: 0 0 pxToRem(4) 0 $color-dark;

    &_header {
      background-color: #01AEC9;
      color: $color-dark;

      &_title {
        font-size: 16px;
        font-weight: 500;
      }
    }

    &_headerDisabled {
      background-color: #98dee9;
      color: #989898;

      &_title {
        font-size: 16px;
        font-weight: 500;
      }
    }

    &_body {
      display: flex;
      align-items: center;
      justify-content: center;
      &_content {
        display: flex;
        justify-content: space-between;
        width: 100%;
      }
    }

    &_bodyDisabled {
      color: #babbbb;
    }

    &_list {
      font-size: pxToRem(14);
      list-style: none;
      margin: 0;
      padding: 0;

      &_item {}

      &_title {
        margin-bottom: pxToRem(4);
        text-decoration: underline;
        font-weight: 400;
      }
    }

    &_openDetails {
      background-color: rgba($color-dark, 0.2);
      border: none;
      cursor: pointer;
      bottom: 0;
      left: 0;
      max-height: pxToRem(20);
      right: 0;
      transition: background-color 0.15s linear;

      &_icon {
        outline: none;
        vertical-align: baseline;
      }

      &:hover,
      &:focus {
        background-color: rgba($color-dark, 0.4);
        outline: none;

        .BoxVinculador_openDetails_icon {
          fill: $color-white;
          transition: transform 0.15s linear;
        }
      }
    }

    &_rodate_button {
      transform: rotate(180deg);
    }
  }

  .listagemSeloHeader {
    background-color: #ddd !important;
    color: #000;
    padding: 0.7rem 0 0.7rem 0.375rem;
    font-size: 1.2rem;
    font-weight: bold !important;
    font-weight: 400;
    width: 100%;
    display: flex;
    align-items: center;

  }

  .ListagemSelo {
    width: 100%;
    font-size: pxToRem(14);
    padding: 0px pxToRem(5) 0 pxToRem(5);

    &_border_top {
      border-top: 1px dashed rgba(38, 38, 38, 0.4);
    }

    &_detailsBoxInfo {
      &_title,
      &_text {
        font-size: pxToRem(14);
        margin-bottom: pxToRem(4);
      }

      &_title {
        border-bottom: pxToRem(1) solid;
        display: inline-block;
      }

      &_line_height {
        line-height: 1.8;
      }
    }

    &_border_bottom {
      border-bottom: 1px dashed rgba(38, 38, 38, 0.4);
    }

    &_border_all {
      border: 1px solid rgba(38, 38, 38, 0.4);
    }
  }

  .icon-close {
    fill: #8b0000;
    width: 20px;
    height: 20px;
  }

  .icon-done {
    fill: #008b27;
    width: 20px;
    height: 20px;
  }

  .icon-close-disabled {
    fill: #d09898;
  }

  .icon-done-disabled {
    fill: #98d0a8;
  }

  .selos-table {
    height: 30px;
    display: flex;
    align-items: center;
  }

  /deep/ .dropdown-menu {
    min-width: 1rem !important;
    width: 100% !important;
  }

  /deep/ .dropdown-item {
    //font-size: 15px;
    font-size: pxToRem(13);
    padding: 0.25rem 0.7em;
  }

  /deep/ .dropdown-item:hover {
    background-color: #5897FB;
    color: #FFFFFF;
  }
</style>
